/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Max_Cps_Characters_SecInputs */



/**
* | output |
* | --- |
* | "Max CPS (Characters/sec)" |
*
* @param {Max_Cps_Characters_SecInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const max_cps_characters_sec = /** @type {((inputs?: Max_Cps_Characters_SecInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Max_Cps_Characters_SecInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("CPS max (caract./sec)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Maximale Klicks pro Sekunde (Zeichen/Sek.)")
	if (locale === "it") return /** @type {LocalizedString} */ ("CPS massimo (caratteri/sec)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Максимальная скорость передачи символов в секунду (CPS)")
	if (locale === "es") return /** @type {LocalizedString} */ ("CPS máximo (caracteres/seg)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("最大每秒字符数 (CPS)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最大CPS（文字/秒）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अधिकतम सीपीएस (अक्षर/सेकंड)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("CPS máximo (caracteres/seg)")
	return /** @type {LocalizedString} */ ("Max CPS (Characters/sec)")
});